module.exports = __webpack_public_path__ + "static/media/hackathon-of-humanoid-robots-3.3c19c105.png";